/*
 * Copyright (c) 2026 Cloudcharge AB.
 * All Rights Reserved.
 */

/**
 * The themes' code font: named fonts before the generic, so it's the same font every time.
 *
 * A bare `monospace` is whichever font the system picks for it. On the Linux CI runner, which has
 * several, Chromium resolved it to WenQuanYi Zen Hei Mono, a Chinese font whose Latin letters are
 * narrower, on some renders and Liberation Mono on others. The theme stories' token tables then
 * changed width between two renders of the same story, and the visual diff flagged them.
 *
 * ui-monospace, the system's own monospace, comes after the named fonts too: where a browser maps
 * it to whatever the system calls monospace, it would bring the same problem back.
 */
export const fontCode =
    'SFMono-Regular, Menlo, Consolas, "Liberation Mono", ui-monospace, monospace';
